import { useCallback, useState } from 'react';

export type OnAbsentAd = (elementId: string) => void;

export const useAbsentAdHandler = (
    elementId: string
): {
    isAbsentAd: boolean;
    onAbsentAd: OnAbsentAd;
} => {
    const [isAbsentAd, setIsAbsentAd] = useState(false);

    const onAbsentAd: OnAbsentAd = useCallback(
        slotAdId => {
            if (slotAdId === elementId) {
                setIsAbsentAd(true);
            }
        },
        [elementId]
    );

    return { isAbsentAd, onAbsentAd };
};
